
<template>
	<c-dialog ref="dialog" title="选择工单" width="100vw-300" height="700" enable-flex @resolve="resolve">
	    <view-list work-type="3" view-id="10016" ref="view" selector :selected-field="{name: 'product_name'}">
	    	<template #search>
	    		<m-search ref="search" column="4" :init-data="initSearchData" :default-data="defaultSearchData" >
				    <m-search-item label="工单编号">
				    	<c-input name="work_code"></c-input>
				    </m-search-item>
				    <m-search-item label="产品编号">
				    	<c-input name="product_code"></c-input>
				    </m-search-item>
				    <m-search-item label="产品名称">
				    	<c-input name="product_name"></c-input>
				    </m-search-item>
				    <m-search-item label="产品规格">
				    	<c-input name="product_spec"></c-input>
				    </m-search-item>
				    <m-search-item label="工单状态" colspan="2">
				    	<c-checkbox-group name="work_states" :options="orderStateDic" multiple></c-checkbox-group>
				    </m-search-item>
				    <m-search-item label="创建时间" colspan="2">
				    	<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
				    </m-search-item>
				    <m-search-item label="">
						<c-checkbox-group name="is_wait_test">
							<c-checkbox value="1">未完成质检</c-checkbox>
						</c-checkbox-group>
				    </m-search-item>
	    		</m-search>
	    	</template>
	    
			<!--产品来源-->
			<template #product_source="{data}">
				<c-state dict="productSourceName" :value="data.product_source"></c-state>
			</template>
			
			<!--产品类型-->
			<template #product_type="{data}">
				<c-state dict="productTypeName" :value="data.product_type"></c-state>
			</template>
			
			<!--工单进度-->
			<template #process_rate="{data}">
				<process-rate :key="data._timestamp" :id="data.id"></process-rate>
			</template>
			
			<!--工单进度%-->
			<template #work_progress="{data}">
				<c-progress :rate="[data.ok_count, data.plan_count]" :color="((data.ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
			</template>
			
			<!--工单明细进度%-->
			<template #work_detail_progress="{data}">
				<c-progress :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
			</template>
			
			<!--工单状态-->
			<template #work_state="{data}">
				<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
			</template>
			
			<!--关联单据-->
			<template #ref_code="{data}">
				<order-link :type="data.ref_type" :id="data.ref_id" :code="data.ref_code"></order-link>
			</template>
	    </view-list>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
	    name: 'workSelector',

		props: {
			warehouseOptions: Array,
			isWaitTest: Boolean
		},

		data() {
			return {
				initSearchData: {},
				defaultSearchData: {
					'work_states': this.isWaitTest ? [3] : [],
					'is_wait_test': this.isWaitTest ? [1] : []
				}
			}
		},
		
		computed: {
			...mapState(['productSourceName', 'productTypeName','orderStateDic'])
		},
		
		methods: {
			open() {
				this.$refs.view.reset();
				this.$refs.dialog.open();
			},
			
			resolve(stop) {
				var data = this.$refs.view.selectedData;
				if (!data.length) {
					stop();
					this.$message({
						message: '请选择产品'
					});
					return;
				}
				this.$emit('resolve', data);
			},
			
			//创建产品后回调
			productEditHandle(data){
				this.$refs.view.update();
			},

			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>